import { ROUTES } from "../../../../module/constants";
import { generalConst } from "../../../../module/globalInterface";

export const SOD_MGMT_CONSOLE_ADMIN_URLS: generalConst = {
  BASE_URL: ROUTES.ADMIN_SOD_MGMT,
  STEP_ONE: `${ROUTES.ADMIN_SOD_MGMT}`,
  CONFLICT_CREATION: `${ROUTES.ADMIN_SOD_MGMT}/conflictCreation`,
  CONFLICT_CREATION_SUMMARY: `${ROUTES.ADMIN_SOD_MGMT}/conflictCreation/summary`,
  CONFLICT_DETAILS: `${ROUTES.ADMIN_SOD_MGMT}/conflictDetails`,
  EXCEPTION_MANAGEMENT: `${ROUTES.ADMIN_SOD_MGMT}/conflictDetails/exceptionManagement`,
  EXCEPTION_CREATION: `${ROUTES.ADMIN_SOD_MGMT}/conflictDetails/exceptionManagement/create`,
};

export const STATE_IDENTIFIER = {
  STEP_ONE: "stepOne",
  LOADER_IDENTIFIER: "loader",
  RESPONSE_STATE: "responseState",
  SOD_CONFLICTS: "sodConflicts",
  CONFLICT_CREATION: "conflictCreation",
  CONFLICT_CREATION_SUMMARY: "conflictCreationSummary",
  CONFLICT_DETAILS: "conflictDetails",
  EXCEPTION_MANAGEMENT: "exceptionManagement",
  EXCEPTION_CREATION: "exceptionCreation",
  SELECTED_CONFLICT: "selectedConflict",
  ALL_ENTITLEMENTS: "allEntitlements",
  SELECTED_ENTITLEMENTS: "selectedEntitlements",
  EXCEPTION_LIST: "exceptionList",
  ALL_USERS: "allUsers",
  SELECTED_USERS: "selectedUsers",
  CONFLICT_TO_MODIFY: "conflictToModify",
};

export enum SodConflictType {
  BLOCK = 1,
  OVERRIDE = 2,
  WARNING = 3,
  WORKFLOW = 4,
}

export const SodConflictTypeLabel = {
  1: "BLOCK",
  2: "OVERRIDE",
  3: "WARNING",
  4: "WORKFLOW",
};

export const SOD_CONFLICT_TYPE_LIST = [
  {
    label: "BLOCK",
    value: 1,
  },
  {
    label: "OVERRIDE",
    value: 2,
  },
  {
    label: "WARNING",
    value: 3,
  },
  {
    label: "WORKFLOW",
    value: 4,
  },
];

export interface ISodConflict {
  id?: string;
  sodConflictId: string;
  inputIdentitySystemId?: string;
  inputEntitlementId?: string;
  inputEntitlementName: string;
  inputEntitlementDescription?: string;
  sodManagementInputEntitlementDescription?: string;
  inputApplicationName: string;
  inputApplicationDescription?: string;
  sodManagementInputApplicationDescription?: string;
  checkIdentitySystemId?: string;
  checkEntitlementId?: string;
  checkEntitlementName: string;
  checkEntitlementDescription?: string;
  sodManagementCheckEntitlementDescription?: string;
  checkApplicationName: string;
  checkApplicationDescription?: string;
  sodManagementCheckApplicationDescription?: string;
  conflictCode: string;
}

export interface ISodManagementEntitlement {
  entitlementId?: string;
  entitlement_id?: string;
  identitySystemId?: string;
  identity_system_id?: string;
  entitlementName?: string;
  entitlement_name?: string;
  entitlementDescription?: string;
  entitlement_description?: string;
  applicationId?: string;
  application_id?: string;
  applicationName?: string;
  application_name?: string;
  applicationDescription?: string;
  application_description?: string;
  showOnFrontend?: boolean;
}
export interface ISodManagementEntitlementBody
  extends ISodManagementEntitlement {
  pageNumber: number;
  pageSize: number;
}
export interface ISodManagementEntitlementResponse {
  pageNumber: number;
  totalElements: number;
  pageTotalNumber: number;
  pageSize: number;
  entitlements: ISodManagementEntitlement[];
}

export interface ISodManagementUser {
  code: string;
  name: string;
  surname: string;
  organizational_unit: string;
  identitySystemId: string;
}
export interface ISodManagementUserBody extends ISodManagementUser {
  pageNumber: number;
  pageSize: number;
}
export interface ISodManagementUserResponse {
  pageNumber: number;
  totalElements: number;
  pageTotalNumber: number;
  pageSize: number;
  users: ISodManagementUser[];
}

export interface ICreateConflictBody {
  inputIdentitySystemId?: string;
  inputEntitlementId?: string;
  checkIdentitySystemId?: string;
  checkEntitlementId?: string;
  conflictCode?: string;
}

export interface ISodException {
  id: string;
  conflictId: string;
  userCode: string;
  name: string;
  surname: string;
  organizationalUnit: string;
  conflictCode: string;
}

export interface IEditExceptionBody {
  userCode: string;
  conflictCode: string;
  conflictId: string;
}
